import type { FC } from "react";
import Icon from "@ch/components/Icons/Icon";
import KemImage from "@ch/assets/images/kem-speech.svg";

interface KemSpeechIdleProps {
  isLoading: boolean;
  onStartRecording: () => void;
}

const KemSpeechIdle: FC<KemSpeechIdleProps> = ({
  isLoading,
  onStartRecording,
}) => {
  return (
    <div className="flex w-full flex-1 flex-col items-center justify-between">
      <div className="mb-8 flex flex-1 items-center justify-center">
        <div className="flex h-[240px] w-[240px] items-center justify-center rounded-full border-2 border-[#4B5565]">
          <img alt="Kem" className="h-32 w-32" src={KemImage} />
        </div>
      </div>

      <div className="w-full max-w-md gap-4">
        <button
          className="flex h-20 w-full items-center justify-center gap-4 rounded-full border border-[#3A4047] bg-[#1E2125] px-3 transition-transform hover:scale-105 active:scale-95 disabled:opacity-50"
          disabled={isLoading}
          onClick={onStartRecording}
          type="button"
        >
          {isLoading ? (
            <div className="flex gap-2">
              <div className="h-2 w-2 animate-bounce rounded-full bg-white [animation-delay:-0.3s]" />
              <div className="h-2 w-2 animate-bounce rounded-full bg-white [animation-delay:-0.15s]" />
              <div className="h-2 w-2 animate-bounce rounded-full bg-white" />
            </div>
          ) : (
            <Icon color="#FFFFFF" name="microphone" size={35} />
          )}
        </button>

        <div className="mt-4 text-center">
          <p className="text-xs text-gray-400">AI information can be wrong x</p>
        </div>
      </div>
    </div>
  );
};

export default KemSpeechIdle;
